import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { useDispatchTrackClickEvent } from "@grandvisionhq/svc-tealium/events";
import { useSessionStorage } from "@grandvisionhq/utils";
import { useIsGooglePaySupportedForCart } from "../../../../../../hooks/hooks/use-is-google-pay-supported-for-cart.js";
import { GooglePayButton } from "./GooglePayExpressCheckoutButton.js";
import { ExpressPaymentMethod, PaymentMethod } from "../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const GooglePayExpressCheckoutButtonContainer = ({
  cartId,
  cartHash,
  onClickHandler
}) => {
  const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
  const cartLink = useLink({ route: "cart.overview" });
  const expressCheckoutLink = useLink({
    route: "express-checkout",
    params: {
      type: ExpressPaymentMethod.GOOGLE_PAY,
      returnPath: cartLink?.href,
      cartId,
      ...cartHash ? { cartHash } : null
    }
  });
  const { isGooglePaySupportedForCart, called, loading, paymentConfiguration } = useIsGooglePaySupportedForCart(cartId);
  const [_, setConfiguration] = useSessionStorage(
    "payment-configuration",
    void 0,
    (value) => !value
  );
  const handleOnClick = React.useCallback(() => {
    dispatchTealiumTrackEvent({
      data_element_id: "Summary_GooglePayCheckout",
      data_description: "checkout_with_googlepay"
    });
    onClickHandler && onClickHandler(PaymentMethod.GOOGLE_PAY);
    setConfiguration(paymentConfiguration);
    expressCheckoutLink?.onClick();
  }, [
    dispatchTealiumTrackEvent,
    expressCheckoutLink,
    onClickHandler,
    paymentConfiguration,
    setConfiguration
  ]);
  if (!isGooglePaySupportedForCart || !called || loading) {
    return null;
  }
  if (!expressCheckoutLink) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(GooglePayButton, { onClick: handleOnClick });
};
export {
  GooglePayExpressCheckoutButtonContainer
};
//# sourceMappingURL=GooglePayExpressCheckoutButtonContainer.js.map
